import { render, staticRenderFns } from "./EditAgencyModal.vue?vue&type=template&id=25d588b2"
import script from "./EditAgencyModal.vue?vue&type=script&lang=ts"
export * from "./EditAgencyModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports